export const APP_RESUME_EVENT = 'sweetspot:app-resume';
